import React, { useEffect } from 'react';
import useSite from '../../hooks/api/useSite';
import { CircularProgress } from '@material-ui/core';

const SiteRedirection = ({ history, match }) => {
  const { id } = match.params;
  const { get } = useSite();

  useEffect(() => {
    if (id) {
      get(id).then((site) => {
        history.push(`/dashboard/customer/${site.legacyCustomerId}`);
      });
    }
  }, [id]);

  return <CircularProgress size={17} />;
};

export default SiteRedirection;
